export enum ClientType {
    IITED = 'ii-ted',
    IWSA = 'iwsa'
}